/* eslint-disable require-jsdoc */
import React, {useState, useEffect} from 'react';
import {getMonth} from '../../utils/date';
import {isValid} from '../../utils/validate.js';
import hasProp from 'hasprop';
import ensuringCorrectYear from '../../utils/ensuringCorrectYear';
import {TimeForPopUp} from '../../utils/TimeOrNoTime';


const Event = (props) => {

  return (

    <div>
      {hasProp(props, ['event']) ?
       <div>
         <section className="hearby-section-summarydetails">
           <div className="hearby-details-row">
             <div className="hearby-col hearby-col-40">

               {isValid(props.event.eventImage) ?
               <img src={props.event.eventImage}
                 onError={(e)=>{
                  //  console.log('event image error 1 ', props.event.eventImage,
                  //                props.defaultImage());
                   e.target.onerror = null;
                   if(e.target.src!==props.defaultImage().split(' ')[0]){
                    e.target.src= props.defaultImage().split(' ')[0];
                   } else {
                    e.target.src= props.defaultImage().split(' ')[1];
                   }
                 }}
                 className="hearby-details-eventimage" /> :

                 <img src={props.defaultImage()}
                   onError={(e)=>{
                    console.log('event image error 2 ');
                     e.target.onerror = null;
                     e.target.src=props.defaultImage();
                   }}
                   className="hearby-details-eventimage" />
               }

             </div>

             <div className="hearby-col hearby-col-60">
               <div className="hearby-event-modal-description">
                 <div className="hearby-event-modal-description">
                   <h1>{isValid(props.event.event) ?
                   props.event.event: null}</h1>
                   <div className='hearby-venue-details'>
                     <span className='hearby-details-datetime'>

                       {isValid(getMonth(props.event.month)) ?
                        getMonth(props.event.month)+' ': null}

                       {isValid(props.event.day) ? props.event.day+', ': null }

                       {isValid(props.event.datetimeUTC) ?
                          ensuringCorrectYear(props.event.datetimeUTC):
                          null}

                        <TimeForPopUp event={props.event}/>

                     </span>
                     <span className='hearby-details-sep'>at</span>
                     <span className='hearby-details-venuename'>
                       {isValid(props.venue.venueName) ?
                        props.venue.venueName:
                        null}
                     </span>
                     <span className='hearby-details-venue-address'>
                       {isValid(props.venue.address) ?
                          props.venue.address: null}
                     </span>
                   </div>


                   <div className="hearby-event-modal-buttons">
                     { isValid(props.event.ticketLink) ?
                       <a href={`${props.event.ticketLink}`}
                         className="hearby-ticketlink">
                           Buy tickets
                       </a> : null}
                   </div>

                 </div>

               </div>

             </div>

           </div>

         </section>

       </div> : null}

    </div>
  );
};

export default Event;
